jQuery(document).on("click", "[data-behaviour~=mychart-scheduling-link]", function (event) {
  event.preventDefault();

  window.open(jQuery(this).attr("href"), "", "scrollbars=1,resizable=1,height=700,width=850");
});
